"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleTypes = exports.CLIP_TYPES = exports.OPEN_EMBED_GATE = exports.HIGHLIGHT_ENTITY_TYPE = exports.ATOMIC_TYPES = exports.ENTITY_TYPES = exports.DRAFT_DATA_OFFSET_KEY_SUFFIX = exports.IMAGE_COMPONENT_CLASSNAME = exports.VIDEO_COMPONENT_CLASSNAME = exports.EMBED_COMPONENT_CLASSNAME = void 0;
var EMBED_COMPONENT_CLASSNAME = 'embed-component';
exports.EMBED_COMPONENT_CLASSNAME = EMBED_COMPONENT_CLASSNAME;
var VIDEO_COMPONENT_CLASSNAME = 'video-component';
exports.VIDEO_COMPONENT_CLASSNAME = VIDEO_COMPONENT_CLASSNAME;
var IMAGE_COMPONENT_CLASSNAME = 'image-plugin-component'; // string appended to Draft block keys in editor, also used to match w/ conversations

exports.IMAGE_COMPONENT_CLASSNAME = IMAGE_COMPONENT_CLASSNAME;
var DRAFT_DATA_OFFSET_KEY_SUFFIX = '-0-0';
exports.DRAFT_DATA_OFFSET_KEY_SUFFIX = DRAFT_DATA_OFFSET_KEY_SUFFIX;
var ENTITY_TYPES = {
  change: 'CHANGE',
  clip: 'CLIP',
  image: 'IMAGE',
  link: 'LINK',
  video: 'VIDEO',
  embed: 'EMBED',
  questionAndAnswer: 'QUESTION_AND_ANSWER',
  interactiveSalesContent: 'INTERACTIVE_SALES_CONTENT'
};
exports.ENTITY_TYPES = ENTITY_TYPES;
var ATOMIC_TYPES = {
  image: 'IMAGE'
};
exports.ATOMIC_TYPES = ATOMIC_TYPES;
var HIGHLIGHT_ENTITY_TYPE = 'HIGHLIGHT';
exports.HIGHLIGHT_ENTITY_TYPE = HIGHLIGHT_ENTITY_TYPE;
var OPEN_EMBED_GATE = 'KnowledgeContent:OpenEmbed';
exports.OPEN_EMBED_GATE = OPEN_EMBED_GATE;
var CLIP_TYPES = {
  ALL: -1,
  FULL_PAGE: 0,
  QUOTE: 1,
  IMAGE: 2
};
exports.CLIP_TYPES = CLIP_TYPES;
var ToggleTypes = {
  BLOCK: 'block',
  ENTITY: 'entity',
  INLINE: 'inline'
};
exports.ToggleTypes = ToggleTypes;